import axios from 'axios'
const API_URL = process.env.REACT_APP_BASE_API_URL

export const GET_UPLOAD_SIGNATURE = `${API_URL}/transloadit_signature`
export const SAVE_FILE = `${API_URL}/file/save`
export const RECORD_FILE = `${API_URL}/recordskeeper/records/file`

export const getUploadSign = (
  resourceType: string | undefined,
  assemblyOption: string,
  companyId: any
) => {
  return axios.post(
    GET_UPLOAD_SIGNATURE,
    {resourceType, assemblyOption},
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const saveFile = (data: any) => {
  return axios.post(SAVE_FILE, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const recordFile = (
  data: any,
  companyId: any,
  isNewVersionFile?: boolean,
  recordId?: string
) => {
  return axios.post(
    `${RECORD_FILE}${
      isNewVersionFile && recordId
        ? `?isNewVersionFile=${isNewVersionFile}&recordId=${recordId}`
        : ''
    }`,
    data,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}
